import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import LabelIcon from '@mui/icons-material/Label';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import * as React from 'react';
import Countdown from 'react-countdown';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import PricingDetailsComp from '@/components/ui/PricingDetailsComp';
import Hidden from '@/components/ui/TzoHidden';
import W2Popup from '@/components/ui/W2Popup';
// import W2Popup from '@/components/ui/W2Popup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

const FormW2 = () => {
  const [open, setOpen] = useState(false);
  const [closeSticky, setCloseSticky] = useState<boolean>(false);

  // const [hoveredImageIndex, setHoveredImageIndex] = useState<
  //   string | null
  // >(null);

  // const handleMouseOver = (index: string) => {
  //   setHoveredImageIndex(index);
  // };

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Simplify Your W-2 Filing Process`,
  //   SubHeading: `E-file your W-2 forms now with TaxZerone for a hassle-free experience.`,
  //   CtaText: 'File W-2  Now!',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`,
  //   isActive: true,
  // };

  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());
  const handleStickyClose = (): void => {
    setCloseSticky(true);
  };

  React.useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 2, 2));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 2, 2)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);

  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1,
            pt: 0.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 60, md: 60 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 20 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.2 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 10 },
            fontWeight: 500,
            color: '#ccc',
            mt: 0,
            mx: -1,
            mb: -1,
            py: 0.2,
            px: { xs: 0, sm: 0, lg: 0 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Days</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-file IRS Form W-2 for 2025 Tax Year | TaxZerone®"
          description="File your 2025 W2 form online with TaxZerone. Easily report employee wages, tips, and other tax information while staying compliant with SSA and IRS deadlines."
          keywords="W-2 form, Wage and Tax Statement, W-2 Reporting"
          canonical="information-returns/efile-irs-form-w2/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="57448"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <Hidden smDown>
        {!closeSticky && (
          <Box
            component="section"
            sx={{
              position: 'fixed',
              bottom: 0,
              width: '100%',
              left: 0,
              right: 0,
              zIndex: 3,
            }}
          >
            <Container
              maxWidth="lg"
              sx={{
                backgroundColor: '#fff',
                mx: { xs: 3, lg: 'auto' },
                width: 'auto',
                py: 1.5,
                borderTopLeftRadius: 6,
                borderTopRightRadius: 6,
                boxShadow: '0 0 20px rgba(0,0,0,.5)',
                position: 'relative',
                borderWidth: 2,
                borderColor: '#414042',
                borderStyle: 'solid',
                borderBottom: 'none',
              }}
            >
              <Tooltip title="Close" arrow placement="top">
                <IconButton
                  aria-label="close"
                  size="small"
                  onClick={handleStickyClose}
                  sx={{
                    position: 'absolute',
                    right: -12,
                    top: -12,
                    color: '#fff',
                    backgroundColor: '#e11d1d',
                    '&:hover, &:focus': {
                      backgroundColor: '#b01919',
                    },
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 1, sm: 1, md: 2 }}
                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
              >
                <Box>
                  <Typography
                    variant="body1"
                    sx={{
                      textAlign: { xs: 'center', sm: 'left' },
                      fontSize: { xs: 15, sm: 17, md: 18, lg: '1.25rem' },
                      //  color: '#ccc',
                      lineHeight: 1.3,
                    }}
                  >
                    <strong> 📢 Deadline passed! </strong> E-file your{' '}
                    <b style={{ fontWeight: 600, color: '#213e99' }}>
                      2025 W-2 Forms
                    </b>{' '}
                    now to minimize IRS penalties!
                  </Typography>
                </Box>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Countdown date={lastDayTaxSeason} renderer={renderer} />
                  <Hidden mdUp>
                    <Box sx={{ textAlign: 'center' }}>
                      <Button
                        variant="contained"
                        size="medium"
                        href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
                        sx={{
                          textTransform: 'none',
                          px: 2.5,
                          display: 'inline-block',
                          boxShadow: 'none',
                          borderRadius: 4.2,
                          backgroundColor: '#213e99',
                          whiteSpace: 'nowrap',
                          '&:hover, &:focus': {
                            backgroundColor: '#172b6b',
                          },
                        }}
                      >
                        E-File Now
                      </Button>
                    </Box>
                  </Hidden>
                </Stack>
                <Hidden mdDown>
                  <Box sx={{ textAlign: 'center' }}>
                    <Button
                      variant="contained"
                      size="medium"
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
                      sx={{
                        textTransform: 'none',
                        px: 2.5,
                        display: 'inline-block',
                        boxShadow: 'none',
                        borderRadius: 4.2,
                        backgroundColor: '#213e99',
                        whiteSpace: 'nowrap',
                        '&:hover, &:focus': {
                          backgroundColor: '#172b6b',
                        },
                      }}
                    >
                      E-File Now
                    </Button>
                  </Box>
                </Hidden>
              </Stack>
            </Container>
          </Box>
        )}
      </Hidden>
      <W2Popup />
      <InformationSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      <Stack
        component="section"
        direction={{ xs: 'column', sm: 'row' }}
        alignItems="center"
        justifyContent="center"
        spacing={{ xs: 1, sm: 2 }}
        sx={{
          position: { xs: 'relative', sm: 'sticky' },
          background:
            'linear-gradient(275deg,rgba(18, 98, 144, 1) 0%, rgba(38, 63, 54, 1) 100%)',
          p: 1.5,
          px: 2.5,
          color: '#fff',
          minHeight: 40,
          left: 0,
          right: 0,
          zIndex: 11,
          textAlign: 'center',
          top: { xs: 0, sm: 114, md: 118 },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: '#e1e1e1',
            lineHeight: 1.3,
            fontSize: { xs: 14, sm: 16, md: 18, lg: 20 },
          }}
        >
          ⚠️The deadline has passed. E-file your{' '}
          <span style={{ fontWeight: 600, color: '#ecf39e' }}>
            W-2, 1099-NEC & 94X forms
          </span>{' '}
          now to minimize IRS penalties.
        </Typography>
        <Button
          variant="contained"
          size="small"
          href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
          sx={{
            backgroundColor: '#fff',
            '&:hover, &:focus': {
              backgroundColor: '#156e98',
              color: '#fff',
            },
            minWidth: 180,
            px: 2,
            py: 0.5,
            color: '#333',
            mt: { xs: 0, md: 0 },
            display: { xs: 'inline-block', sm: 'inline-block' },
            mx: { xs: 'auto', sm: 1 },
            borderRadius: 2,
            boxShadow: 'none',
            fontSize: { xs: 12, sm: 14, md: 16 },
            textTransform: 'none',
          }}
        >
          E-File Form W-2 Now
        </Button>
      </Stack>

      <Container
        component="section"
        maxWidth="xl"
        sx={{ mt: { sm: 3, md: 3 } }}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                File{' '}
                <span className="highlight-container">
                  <span className="highlight">W2 Form</span>
                </span>{' '}
                for Tax Year 2025
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Report employee wages and taxes with TaxZerone’s accurate and
                hassle-free e-filing solution for Form W-2.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box sx={{ textAlign: 'center', mr: { xs: 0, md: 4 } }}>
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
                  >
                    E-file{' '}
                    <Box
                      component="span"
                      sx={{ ml: 1, color: '#eaff00', fontWeight: 700 }}
                    >
                      Form W-2 Now
                    </Box>
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes less than 5 minutes
                  </Typography> */}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/w2-landing-img.webp" />
                <source srcSet="/assets/images/w2-landing-img.png" />
                <img
                  src="/assets/images/w2-landing-img.png"
                  alt="File W2 Form for Tax Year 2025"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/w2-landing-img-sm.webp" />
                <source srcSet="/assets/images/w2-landing-img-sm.png" />
                <img
                  src="/assets/images/w2-landing-img-sm.png"
                  alt="File W2 Form for Tax Year 2025"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Pricing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                Start at just{' '}
                <Box
                  component="strong"
                  sx={{
                    color: '#ffe400',
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $2.49
                </Box>
                , with pricing as low as{' '}
                <Box
                  component="strong"
                  sx={{
                    fontSize: { xs: 24, sm: 30 },
                  }}
                >
                  $0.59
                </Box>{' '}
                per form for bulk filings.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Paper
                variant="outlined"
                sx={{
                  p: { xs: 3, sm: 4, md: 6 },
                  borderRadius: 10,
                  backgroundColor: '#f5f6f7',
                  maxWidth: 800,
                  mx: 'auto',
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 4,
                    textAlign: 'center',
                  }}
                >
                  Filing Requirements for Form W-2
                </Typography>

                <Typography variant="body1" sx={{ textAlign: 'center', mb: 2 }}>
                  Ensure a smooth filing process by gathering these details:
                </Typography>
                <Box
                  sx={{
                    justifyContent: 'center',
                    px: { xs: 0, sm: 2, md: 12 },
                  }}
                >
                  <List>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> Employer Information:</b> Employer’s Name, EIN, and
                        Address.
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b>Employee Information:</b> Employee’s Name, SSN, and
                        Address.
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> Wage Information:</b> Wages, tips, other
                        compensation, and federal income tax withheld.
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{
                          minWidth: 'inherit',
                          mr: 1,
                          mt: 0.6,
                          color: '#1da94a',
                        }}
                      >
                        <LabelIcon />
                      </ListItemIcon>
                      <ListItemText sx={{}}>
                        <b> State Tax Information:</b> State ID Number, State
                        Wages and State Income Tax
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 }, mb: 2 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to E-File W2 Form for Tax Year 2025?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                Filing your Form W-2 with TaxZerone is fast, easy, and secure.
                Here&apos;s how you can do it:
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/w2-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/w2-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  srcSet="/assets/images/w2-steps-img.png"
                  alt="3 Simple Steps to Complete Your Form W-2 E-filing"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  m: 'auto',
                }}
              >
                <Box
                  component="ol"
                  sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                    p: 2,
                    pl: 0,
                    ml: { xs: 0, sm: 0, md: -2 },
                  }}
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          my: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source
                            srcSet="/assets/images/step-1-icon.webp"
                            width={39}
                            height={39}
                          />
                          <source
                            srcSet="/assets/images/step-1-icon.png"
                            width={39}
                            height={39}
                          />
                          <img
                            src="/assets/images/step-1-icon.png"
                            alt="Enter Information for Form W-2"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        Enter Information for Form W-2
                      </Typography>
                      <Typography variant="body1">
                        Fill in your business details (EIN), employee
                        information (name, SSN, address), and wage details.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>

                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          m: 0,
                          mt: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-2-icon.webp" />
                          <source srcSet="/assets/images/step-2-icon.png" />
                          <img
                            src="/assets/images/step-2-icon.png"
                            alt="Review & Transmit"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        Review & Transmit
                      </Typography>
                      <Typography variant="body1">
                        Verify the accuracy with TaxZerone’s SSA validations and
                        securely e-file your Form W-2.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>

                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          mt: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-3-icon.webp" />
                          <source srcSet="/assets/images/step-3-icon.png" />
                          <img
                            src="/assets/images/step-3-icon.png"
                            alt="Send Employee Copies"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          fontWeight: 600,
                          mt: 0,
                          mb: 1,
                          color: '#36324a',
                        }}
                      >
                        Send Employee Copies
                      </Typography>
                      <Typography variant="body1">
                        Use ZeroneVault for secure electronic delivery or choose
                        traditional postal mailing.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                </Box>
              </Box>

              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
                >
                  E-file Form W-2
                </Button>
                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    mb: { xs: 2, sm: 2, md: 5 },
                    ml: { xs: 0, md: 8 },
                  }}
                >
                  Takes only 3 steps
                </Typography>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone for W2 E-filing?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone is the trusted e-filing solution for businesses of all
                sizes. Here’s why:
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-rule-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-rule-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-rule-icon.png"
                      alt="SSA Form Validations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  SSA Form Validations
                </Typography>
                <Typography variant="body1">
                  TaxZerone automatically validates your Form W-2 to ensure
                  accuracy and compliance. Our system reduces the risk of errors
                  or rejections by the SSA.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Supports bulk upload"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Supports bulk upload
                </Typography>
                <Typography variant="body1">
                  Easily upload multiple forms at once, saving time and effort,
                  whether you’re filing for a small team or a large workforce.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Share Employee Copies"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Share Employee Copies
                </Typography>
                <Typography variant="body1">
                  Easily distribute employee copies securely through ZeroneVault
                  for electronic delivery or choose traditional postal mail for
                  physical copies.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Best price in the industry"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Best price in the industry
                </Typography>
                <Typography variant="body1">
                  TaxZerone offers competitive pricing tailored to your filing
                  volume, ensuring affordability without compromising on
                  quality.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-based-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-based-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-based-icon.png"
                      alt="Form-based filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Form-based filing
                </Typography>
                <Typography variant="body1">
                  Easily input your data directly into our user-friendly
                  platform, and we’ll handle the rest.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided filing
                </Typography>
                <Typography variant="body1">
                  Receive step-by-step guidance, helpful prompts, and real-time
                  assistance to confidently complete your form W-2 filing.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          pb: 15,
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                Important Deadlines for Filing W-2 Form 2025
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={2}
            mt={2}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/recipient-copies-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/recipient-copies-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/recipient-copies-icon.png"
                      alt="Send Recipient Copies"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Send Employee Copies
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    February 02, 2026
                  </span>{' '}
                  <br />
                  Deliver employee copies securely through ZeroneVault or opt
                  for traditional postal mail.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="File with the SSA (e-file)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with the SSA (e-file)
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    February 02, 2026
                  </span>{' '}
                  <br />
                  Submit your Form W-2 electronically.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/paper-file-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/paper-file-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/paper-file-icon.png"
                      alt="File with the SSA (paper)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  File with the SSA (paper)
                </Typography>
                <Typography variant="body1">
                  <b> Deadline:</b>{' '}
                  <span style={{ color: '#cc2936', fontWeight: 600 }}>
                    February 02, 2026
                  </span>{' '}
                  <br />
                  Mail your Form W-2 if filing on paper.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={12}>
              <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Save time and stress with TaxZerone. File your form W-2 on
                  time and effortlessly.
                </Typography>
                <Button
                  variant="contained"
                  sx={{
                    mt: 2,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
                >
                  Start Filing Now!
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box component="section" sx={{ px: { xs: 4, sm: 3, lg: 0 } }}>
        <Container
          maxWidth="lg"
          sx={{
            mb: 6,
            mt: { xs: -15, sm: -20 },
            backgroundColor: '#1d2337',
            backgroundBlendMode: 'soft-light',
            borderRadius: 4,
            p: 3,
            py: 6,
            textAlign: 'center',
          }}
          className="curve-bg"
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              textAlign: 'center',
              color: '#fff',
            }}
          >
            Need More Time to Send Employee Copies?
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, color: '#909090' }}>
            If you’re unable to furnish employee copies of Form W-2 by the due
            date, <br />
            you may request an extension by filing{' '}
            <Link
              href="/resources/tax-extension/form-15397-instructions/"
              sx={{ color: '#fff8bc', textDecoration: 'underline' }}
            >
              Form 15397
            </Link>{' '}
            with the IRS.
          </Typography>
          <Box
            sx={{
              textAlign: 'center',
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              m: 0,
              mt: 3,
            }}
          >
            <List sx={{ mb: 0 }}>
              <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                <ListItemIcon
                  sx={{
                    minWidth: 'inherit',
                    mr: 1,
                    mt: 0.6,
                    color: '#1da94a',
                  }}
                >
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText sx={{ color: '#ccc' }}>
                  Grants{' '}
                  <span style={{ fontWeight: 600, color: '#fff' }}>
                    one additional 30-day extension
                  </span>{' '}
                  to furnish recipient statements
                </ListItemText>
              </ListItem>
              <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                <ListItemIcon
                  sx={{
                    minWidth: 'inherit',
                    mr: 1,
                    mt: 0.6,
                    color: '#1da94a',
                  }}
                >
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText sx={{ color: '#ccc' }}>
                  Must be filed on or before the original due date
                </ListItemText>
              </ListItem>
              <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                <ListItemIcon
                  sx={{
                    minWidth: 'inherit',
                    mr: 1,
                    mt: 0.6,
                    color: '#1da94a',
                  }}
                >
                  <CheckCircleIcon />
                </ListItemIcon>
                <ListItemText sx={{ color: '#ccc' }}>
                  Applies only to furnishing employee copies (does{' '}
                  <span style={{ fontWeight: 600, color: '#fff' }}>not</span>{' '}
                  extend SSA filing deadlines)
                </ListItemText>
              </ListItem>
            </List>
          </Box>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={{ xs: 0, md: 0 }}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid
              size={12}
              textAlign="center"
              mt={{ xs: 0, md: 0 }}
              mb={{ xs: 0, sm: 0, md: 0 }}
            >
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-secondary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
              >
                Get Extension Now
              </Button>
              <Typography variant="body2" sx={{ mt: 1, color: '#909090' }}>
                With TaxZerone, you can{' '}
                <Link
                  href="/tax-extension/file-irs-form-15397-online/"
                  sx={{ color: '#fff8bc', textDecoration: 'underline' }}
                >
                  file Form 15397
                </Link>{' '}
                and fax it securely to the IRS.
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5, mt: 5 }}>
          <PricingDetailsComp formName="Form W-2" colorCode="#4269e2" />
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} sx={{ textAlign: 'center' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,

                  textAlign: 'center',
                }}
              >
                W2 State Filing
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Did you know that some states require separate filings for Form
                W2 in addition to the federal filing?
                <Hidden mdDown>
                  <br />
                </Hidden>
                Ensure compliance with state-specific tax laws by filing in all
                required jurisdictions.
              </Typography>
            </Grid>

            <Grid
              container
              spacing={2}
              className="MuiGrid-root-width"
              justifyContent="center"
              sx={{
                '& .MuiPaper-root:hover': {
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                  transition: '0.3s',
                  borderColor: '#ccc',
                },
              }}
            >
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/alabama-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      cursor: 'pointer',
                      // width: { md: 'auto', sm: '250px !important', xs: 'auto' },
                      maxWidth: '100%',
                      minHeight: '100%',
                      alignSelf: 'center',
                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',
                        alignSelf: 'center',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',

                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/alabama-flag.svg"
                        loading="lazy"
                        alt="alabama"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',

                        // sm: '15px !important',
                      }}
                    >
                      Alabama
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/arizona-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      width: { md: 'auto', sm: '250px', xs: 'auto' },
                      maxWidth: '100%',
                      minHeight: '100%',
                      alignSelf: 'center',
                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',
                        alignSelf: 'center',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/arizona-flag.svg"
                        loading="lazy"
                        alt="arizona-flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Arizona
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/arkansas-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/arkansas-flag.svg"
                        loading="lazy"
                        alt="Arkansas flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Arkansas
                    </Typography>
                  </Paper>
                </Link>
              </Grid>

              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/colorado-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/colorado-flag.svg"
                        loading="lazy"
                        alt="colorado flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Colorado
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/connecticut-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/connecticut-flag.svg"
                        loading="lazy"
                        alt="connecticut flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Connecticut
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/delaware-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/delaware-flag.svg"
                        loading="lazy"
                        alt="delaware flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Delaware
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/district-of-columbia-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/dist-columbia-flag.svg"
                        loading="lazy"
                        alt="Dist. of Columbia flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Dist. of Columbia
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/georgia-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/georgia-flag.svg"
                        loading="lazy"
                        alt="georgia flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Georgia
                    </Typography>
                  </Paper>
                </Link>
              </Grid>

              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/hawaii-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/hawaii-flag.svg"
                        loading="lazy"
                        alt="hawaii flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Hawaii
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/idaho-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/flag-idaho.svg"
                        loading="lazy"
                        alt="Idaho flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Idaho
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/illinois-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/illinois-flag.svg"
                        loading="lazy"
                        alt="illinois flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Illinois
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/indiana-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/indiana-flag.svg"
                        loading="lazy"
                        alt="indiana flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Indiana
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/iowa-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/iowa-flag.svg"
                        loading="lazy"
                        alt="iowa flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Iowa
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/kansas-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/kansas-flag.svg"
                        loading="lazy"
                        alt="kansas flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Kansas
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/kentucky-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/kentucky-flag.svg"
                        loading="lazy"
                        alt="kentucky flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Kentucky
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/louisiana-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/louisiana-flag.svg"
                        loading="lazy"
                        alt="Louisiana flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Louisiana
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/maine-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/maine-flag.svg"
                        loading="lazy"
                        alt="Maine flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Maine
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/maryland-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/maryland-flag.svg"
                        loading="lazy"
                        alt="Maryland flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Maryland
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/massachusetts-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/massachusetts-flag.svg"
                        loading="lazy"
                        alt="Massachusetts flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Massachusetts
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/michigan-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/michigan-flag.svg"
                        loading="lazy"
                        alt="michigan flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Michigan
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/minnesota-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/minnesota-flag.svg"
                        loading="lazy"
                        alt="minnesota flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Minnesota
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/mississippi-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/mississippi-flag.svg"
                        loading="lazy"
                        alt="mississippi flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Mississippi
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/missouri-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/missouri-flag.svg"
                        loading="lazy"
                        alt="Missouri flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Missouri
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/montana-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/montana-flag.svg"
                        loading="lazy"
                        alt="Montana flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Montana
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/nebraska-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/nebraska-flag.svg"
                        loading="lazy"
                        alt="Nebraska flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Nebraska
                    </Typography>
                  </Paper>
                </Link>
              </Grid>

              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/new-jersey-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/new-jersey-flag.svg"
                        loading="lazy"
                        alt="New Jersey flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      New Jersey
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/new-mexico-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/new-mexico-flag.svg"
                        loading="lazy"
                        alt="New mexico flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      New Mexico
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/north-carolina-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/north-carolina-flag.svg"
                        loading="lazy"
                        alt="North Carolina flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      North Carolina
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/north-dakota-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/north-dakota-flag.svg"
                        loading="lazy"
                        alt="North Dakota flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      North Dakota
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/ohio-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/ohio-flag.svg"
                        loading="lazy"
                        alt="ohia flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Ohio
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/oklahoma-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/oklahoma-flag.svg"
                        loading="lazy"
                        alt="Oklahoma flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Oklahoma
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/oregon-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/oregon-flag.svg"
                        loading="lazy"
                        alt="Oregon flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Oregon
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/pennsylvania-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/pennsylvania-flag.svg"
                        loading="lazy"
                        alt="Pennsylvania flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Pennsylvania
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/rhode-island-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/rhode-island-flag.svg"
                        loading="lazy"
                        alt="Rhode Island flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Rhode Island
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/south-carolina-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/south-carolina-flag.svg"
                        loading="lazy"
                        alt="South Carolina flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      South Carolina
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/utah-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/utah-flag.svg"
                        loading="lazy"
                        alt="utah"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Utah
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/vermont-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/vermont-flag.svg"
                        loading="lazy"
                        alt="Vermont flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Vermont
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/virginia-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/virginia-flag.svg"
                        loading="lazy"
                        alt="Virginia flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Virginia
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/west-virginia-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: 'grid',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/west-virginia-flag.svg"
                        loading="lazy"
                        alt="West Virginia flag"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      West Virginia
                    </Typography>
                  </Paper>
                </Link>
              </Grid>

              <Grid size={{ xs: 12, md: 2.5, sm: 3 }}>
                <Link
                  href="/form-w2-state-filing/wisconsin-w-2-filing-requirements/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 3, sm: 2, md: 3 },
                      borderRadius: 3,
                      display: { md: 'grid', sm: 'flex', xs: 'grid' },
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      backgroundColor: '#fdfdfd',
                      transition: 'all 0.3s ease-in-out',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      alignItems: 'center',
                      boxAlign: 'center',
                      maxWidth: '100%',
                      minHeight: '100%',

                      '&:hover': {
                        boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 15px 0px',
                        transition: '0.3s',
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: '24px !important',
                        height: '17px !important',
                        position: 'relative',

                        '& .state-flag': {
                          position: 'absolute',
                          height: '100%',
                          width: '100%',
                          inset: '0px',
                          color: 'transparent',
                        },
                      }}
                    >
                      <img
                        srcSet="/assets/images/state-flag/wisconsin-flag.svg"
                        loading="lazy"
                        alt="Wisconsin"
                        width="100%"
                        height="100%"
                        className="state-flag"
                      />
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: '15px !important',
                      }}
                    >
                      Wisconsin
                    </Typography>
                  </Paper>
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Schedule Filing: Plan Ahead and Stay On Track
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                Prepare your W-2 filings in advance, and let TaxZerone handle
                the submission on your chosen date.
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            mt={2}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
            sx={{ position: 'relative' }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                elevation={0}
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: 'transparent',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                    zIndex: 2,
                    position: 'relative',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/due-date-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/due-date-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/due-date-icon.png"
                      alt="Select Your Filing Date"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Select Your Filing Date
                </Typography>
                <Typography variant="body1">
                  Choose your preferred filing date, and we&apos;ll ensure your
                  Form W-2 is submitted on time.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                elevation={0}
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: 'transparent',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                    zIndex: 2,
                    position: 'relative',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/review-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/review-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/review-icon.png"
                      alt="Ensure Accuracy"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Ensure Accuracy
                </Typography>
                <Typography variant="body1">
                  Employees have the opportunity to review their forms before
                  submission to confirm all details are correct.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                elevation={0}
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: 'transparent',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                    zIndex: 2,
                    position: 'relative',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/smart-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/smart-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/smart-icon.png"
                      alt="Prevent IRS Correction Forms"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Prevent IRS Correction Forms
                </Typography>
                <Typography variant="body1">
                  Scheduling your filing ahead of time helps reduce errors,
                  minimizing the need for IRS correction forms down the line.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid
                size={12}
                sx={{
                  position: 'absolute',
                  zIndex: 1,
                  top: '75px',
                  right: 35,
                  opacity: 0.5,
                }}
              >
                <img
                  src="/assets/images/dot-shape.svg"
                  alt=""
                  width="100%"
                  height="133"
                  style={{ width: '100%', maxWidth: 1100, height: 133 }}
                />
              </Grid>
            </Hidden>
            <Grid size={12}>
              <Box sx={{ mt: 3, textAlign: 'center' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 0,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
                >
                  Schedule Your W-2 Filing
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                }}
              >
                Share Employee Copies for Form W-2 with Ease
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center' }}>
                At TaxZerone, we make it simple to share Form W-2 copies with
                your employees securely and on time.
                <Hidden mdDown>
                  {' '}
                  <br />
                </Hidden>
                Choose the method that works best for your business:
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            mt={2}
            // py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
            sx={{ position: 'relative', mb: 4 }}
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Paper
                elevation={0}
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 5px 0px',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: 'transparent',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'left',
                    alignItems: 'left',
                    m: 0,
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/vault-logo.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/vault-logo.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/vault-logo.png"
                      alt="Secure Delivery via ZeroneVault"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: '20px !important',
                      fontWeight: 600,
                      textAlign: 'left',
                      mt: 1,
                    }}
                  >
                    Secure Delivery via ZeroneVault{' '}
                  </Typography>
                  <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                    <li>
                      <b> Instant Access:</b> Employees can securely access
                      their W-2 forms online, eliminating the need for printing
                      or mailing.
                    </li>
                    <li>
                      <b> Data Security:</b> ZeroneVault ensures that sensitive
                      employee data remains safe during electronic sharing.
                    </li>
                    <li>
                      <b> User-Friendly:</b> Employees can download or print
                      their forms at their convenience.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Paper
                elevation={0}
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'left',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  boxShadow: 'rgba(0, 0, 0, 0.13) 0px 0px 5px 0px',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'left',
                    alignItems: 'left',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Traditional Postal Mailing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box sx={{}}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: '20px !important',
                      fontWeight: 600,
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    Traditional Postal Mailing{' '}
                  </Typography>
                  <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                    <li>
                      <b> Physical Copy:</b> For those who prefer physical
                      copies, TaxZerone offers postal mailing services for W-2
                      forms.
                    </li>
                    <li>
                      <b> Timely Delivery:</b> Employee copies are mailed
                      promptly to meet IRS deadlines, ensuring compliance.
                    </li>
                    <li>
                      <b> Convenience:</b> You can focus on your business while
                      we handle the mailing process for you.
                    </li>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        component="section"
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Get Started with TaxZerone Today
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          File Form W-2 online effortlessly with TaxZerone.
        </Typography>
        <Box
          sx={{
            textAlign: 'center',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            m: 0,
          }}
        >
          <List>
            <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
              <ListItemIcon
                sx={{
                  minWidth: 'inherit',
                  mr: 1,
                  mt: 0.6,
                  color: '#1d1917',
                }}
              >
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText sx={{ color: '#f3f3f3' }}>
                File accurately and stay compliant.
              </ListItemText>
            </ListItem>
            <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
              <ListItemIcon
                sx={{
                  minWidth: 'inherit',
                  mr: 1,
                  mt: 0.6,
                  color: '#1d1917',
                }}
              >
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText sx={{ color: '#f3f3f3' }}>
                Save time with our bulk upload feature.
              </ListItemText>
            </ListItem>
            <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
              <ListItemIcon
                sx={{
                  minWidth: 'inherit',
                  mr: 1,
                  mt: 0.6,
                  color: '#1d1917',
                }}
              >
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText sx={{ color: '#f3f3f3' }}>
                Enjoy the best pricing in the industry.
              </ListItemText>
            </ListItem>
          </List>
        </Box>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=formw2`}
          >
            File Form W-2 Now!
          </Button>
        </Box>
      </Box>
      <Container
        component="section"
        maxWidth="lg"
        aria-labelledby="form-w2-faqs"
      >
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              id="form-w2-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is form w-2?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1">
                      A{' '}
                      <Link
                        href="/resources/information-returns/form-w-2-instructions/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        W-2 form
                      </Link>{' '}
                      is an official document your employer gives you that shows
                      your total earnings and the amount of taxes withheld from
                      your pay for the previous year.
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      Key Details
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        {' '}
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Official Name:
                        </strong>{' '}
                        Wage and Tax Statement.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}> Deadline:</strong>{' '}
                        Employers must send it to you by{' '}
                        <strong style={{ fontWeight: 600 }}>
                          January 31st
                        </strong>{' '}
                        each year.{' '}
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Who receives it:
                        </strong>{' '}
                        Employees who worked as a traditional employee and
                        earned money or had taxes withheld.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}> Purpose:</strong>{' '}
                        Employees use the information reported on your W-2 to
                        accurately prepare and file your federal, state, and
                        applicable local income tax returns.
                      </li>
                    </Box>
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  What is form w-2 used for?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      {' '}
                      A{' '}
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        Form W-2 (Wage and Tax Statement)
                      </strong>{' '}
                      is an official document that employers use to report an
                      employee's total annual earnings and the amount of taxes
                      withheld from their paychecks.
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      Main Purposes of a W-2
                    </Typography>
                    <Box component="ul" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Filing Taxes:
                        </strong>{' '}
                        Employees use the numbers on their W-2 to accurately
                        fill out federal, state, and local income tax returns.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Reporting to the Government:
                        </strong>{' '}
                        Employers send copies to the Internal Revenue Service
                        (IRS) and the Social Security Administration (SSA) to
                        report worker income and ensure tax compliance
                      </li>
                    </Box>
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  When is a w2 filled out?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1">
                      A{' '}
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        W-2 is filled out by the employer,
                      </strong>{' '}
                      not the employee. Employers typically complete Form W-2 at
                      the end of the tax year to report an employee’s wages and
                      taxes withheld. Employers must generally{' '}
                      <strong style={{ fontWeight: 600 }}>
                        {' '}
                        provide the W-2 to employees and file it with the Social
                        Security Administration (SSA) by January 31
                      </strong>{' '}
                      of the following year.{' '}
                      <Link
                        href="/resources/information-returns/form-w-2-due-dates/"
                        sx={{ color: '#0202ff' }}
                      />{' '}
                      W-2 due dates may vary when the deadline falls on a
                      weekend or legal holiday.
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      Employees use the information on their W-2 to prepare
                      their federal income tax return
                    </Typography>
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  How to fill out a w2 form?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      As an employee, you do not fill out Form W-2, Wage and Tax
                      Statement; it is completed by your employer. Employers are
                      required to send W-2 forms to employees by the end of
                      January each year, which employees then use to file their
                      personal tax returns.
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      To fill out a W-2:
                    </Typography>
                    <Box component="ol" sx={{ mb: 0, '& li': { mb: 1.2 } }}>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Enter employer and employee information –
                        </strong>{' '}
                        Provide the employer’s EIN, name, address, and the
                        employee’s name, address, and Social Security number.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Report wages and taxes –
                        </strong>{' '}
                        Enter the employee’s wages, federal income tax withheld,
                        Social Security wages and tax, and Medicare wages and
                        tax in the appropriate boxes.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Complete state and local information –
                        </strong>{' '}
                        Enter applicable state and local wages and taxes.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Complete other applicable boxes –
                        </strong>{' '}
                        Report items such as retirement contributions, dependent
                        care benefits, or other required information.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Review the W-2 –
                        </strong>{' '}
                        Check all information for accuracy before filing.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          File and furnish the W-2 –
                        </strong>{' '}
                        Submit the required copy to the SSA and provide the
                        appropriate copies to the employee
                      </li>
                    </Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      With TaxZerone, employers can simplify W-2 filing by
                      entering or uploading employee information, reviewing
                      filing details, and electronically filing W-2 forms, while
                      built-in validation checks help reduce common data-entry
                      errors.
                    </Typography>
                    <Alert
                      severity="warning"
                      icon={false}
                      sx={{ mt: 2, mb: 0, alignItems: 'end' }}
                    >
                      <b>Note:</b> Filing Form W-2 on time is important;
                      deadlines are missed leads to unnecessary{' '}
                      <Link
                        href="/resources/information-returns/form-w2-penalties/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        penalties
                      </Link>
                      , so keeping track of the applicable filing requirements
                      and{' '}
                      <Link
                        href="/resources/information-returns/2025-form-w2-updates/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        updates of form w-2
                      </Link>
                      .
                    </Alert>
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  How to get w-2 form from previous employer?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      To get a W-2 from a previous employer:
                    </Typography>
                    <Box component="ol" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li style={{}}>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Contact your former employer –
                        </strong>{' '}
                        Ask HR or payroll for a copy of your W-2.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Check your payroll portal –
                        </strong>{' '}
                        Look for your W-2 under Tax Documents or Year-End
                        Statements.
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Request an IRS transcript –
                        </strong>{' '}
                        If you cannot reach your employer, request a{' '}
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Wage and Income Transcript
                        </strong>{' '}
                        from the IRS.{' '}
                      </li>
                      <li>
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Contact the IRS –
                        </strong>{' '}
                        If your employer does not provide the W-2, call the IRS
                        at{' '}
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          800-829-1040
                        </strong>{' '}
                        for assistance.
                      </li>
                    </Box>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      A Wage and Income Transcript can provide the W-2
                      information reported to the IRS and may help you prepare
                      your tax return.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default FormW2;
